export const SET_IS_START_REFERRAL_SETTING = "SET_IS_START_REFERRAL_SETTING";
export const SET_IS_FAILED_REFERRAL_SETTING = "SET_IS_FAILED_REFERRAL_SETTING";
export const SET_IS_SUCCESS_REFERRAL_SETTING =
  "SET_IS_SUCCESS_REFERRAL_SETTING";
export const SET_IS_NEED_TO_RELOAD_REFERRAL_SETTING =
  "SET_IS_NEED_TO_RELOAD_REFERRAL_SETTING";
